import { buildCommandBasedOptionsParser, commandsDefinition } from "../Commons/Options/CommandBasedOptionsParser";
import { buildFormsOptionsDefinition } from "../CLICommands/BuildForms/BuildFormsOptions";
import {
    buildServerCommandDefinition,
    devBuildServerCommandDefinition,
} from "../CLICommands/BuildServer/BuildServerServerOptions";
import { devBuildCommandDefinition } from "../CLICommands/DevBuild/DevBuildOptions";
import { formStatsCommandDefinition } from "../CLICommands/FormStats/FormStatsOptions";
import { initFormCommandDefinition } from "../CLICommands/InitForm/InitFormOptions";
import { localizationCommandDefinition } from "../CLICommands/Localization/LocalizationOptions";
import { upgradeFormCommandDefinition } from "../CLICommands/UpgradeForm/UpgradeFormOptions";
import { renameFilesCommandDefinition } from "../CLICommands/RenameFiles/RenameFilesOptions";

export const parseOptions = buildCommandBasedOptionsParser(
    commandsDefinition(
        buildFormsOptionsDefinition,
        devBuildCommandDefinition,
        buildServerCommandDefinition,
        formStatsCommandDefinition,
        upgradeFormCommandDefinition,
        renameFilesCommandDefinition,
        localizationCommandDefinition,
        devBuildServerCommandDefinition,
        initFormCommandDefinition
    ),
    {
        commandName: "candy",
        commandDescription: "Утилита для работы с исходниками форм. Позволяет собирать и запускать формы.",
    }
);

export type CandyToolOptions = typeof parseOptions;
